import { WebSocketService } from '@/services/WebSocketService';
import { getAuthTokenFromLocalStorage } from '.';

  /**
   * Send subscription payload with JWT token
   */
  export const sendWebSocketSubscribe = (topic: string = "prod"): boolean => {
    const payload = {
      topic,
      action: "subscribe"
    };
    return sendWebSocketPayload(payload);
  }

/**
 * Utility function to send custom WebSocket payload with JWT token
 * 
 * @param payload - The payload to send (will have token added automatically)
 * @param topic - The topic (defaults to "prod")
 * @returns boolean indicating success
 * 
 * @example
 * ```typescript
 * import { sendWebSocketPayload } from '@/utils/websocketSubscription';
 * 
 * const success = sendWebSocketPayload({
 *   action: 'customAction',
 *   data: { some: 'data' }
 * });
 * ```
 */
export const sendWebSocketPayload = (
  payload: Record<string, unknown>, 
  topic: string = "prod"
): boolean => {
  const authToken = getAuthTokenFromLocalStorage();
  
  if (!authToken) {
    console.warn('No valid auth token available in localStorage - cannot send payload');
    return false;
  }
  
  const fullPayload = {
    topic,
    token: authToken,
    ...payload
  };
  
  return WebSocketService.send(fullPayload);
};

/**
 * Utility function to send WebSocket unsubscribe with JWT token from localStorage
 * 
 * @param topic - The topic to unsubscribe from (defaults to "prod")
 * @returns boolean indicating success
 * 
 * @example
 * ```typescript
 * import { sendWebSocketUnsubscribe } from '@/utils/websocketSubscription';
 * 
 * // Unsubscribe from prod topic
 * const success = sendWebSocketUnsubscribe();
 * 
 * // Unsubscribe from custom topic
 * const success2 = sendWebSocketUnsubscribe('custom-topic');
 * ```
 */
export const sendWebSocketUnsubscribe = (topic: string = "prod"): boolean => {
  
  const payload = {
    topic,
    action: "unsubscribe"
  };
  
  return sendWebSocketPayload(payload);
};
